import { useTranslation } from "react-i18next";
import AppointmentsRequestsCard from "../../../../components/requests/AppointmentsRequestsCard";
import { Switch } from "@headlessui/react";
import { useContext, useEffect, useState } from "react";
import classNames from "classnames";
import { ToastContext } from "../../../../App";
import { makeApiRequest, showApiErrorMessages } from "../../../../helpers";
import { ApiResponse } from "../../../../api/apiResponse";
import {
  GetNewStudentsRequests,
  changeTutorsStudentsRequestStatus,
} from "../../../../api/endpoints/tutors/requests";
import RequestsModel from "../../../../api/models/RequestsModel";
import { updateTutor } from "../../../../api/endpoints/tutors/tutors";
import { useAuth } from "../../../../context/AuthContext";

export default function NewStudentsRequests() {
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { currentUser }: any = useAuth();
  const [enabled, setEnabled] = useState(currentUser?.isAvailable);
  const toast = useContext(ToastContext);

  const [requests, setRequests] = useState<RequestsModel[] | null>([]);
  const getNewStudents = () => {
    makeApiRequest(
      () =>
        GetNewStudentsRequests({
          filters: {
            sender_type: "Student",
            is_new_student: true,
            order_by: "-created-at",
            status: "pending",
          },
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] = RequestsModel.fromApiResponse(
            data?.result,
            "receiver"
          );
          setRequests(requestsList);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };
  const changeRequestStatus = (accept: boolean, id: string | number) => {
    if (accept) {
      makeApiRequest(
        () => changeTutorsStudentsRequestStatus(id, { status: "approved" }),
        (response: ApiResponse) => {
          if (response.isSuccess) {
            toast?.success(t("savedSuccessfully"));
            window.location.reload();
          } else {
            response.errorMessages.forEach((errorMessage) => {
              toast?.error(errorMessage);
            });
          }
        }
      );
    } else {
      makeApiRequest(
        () => changeTutorsStudentsRequestStatus(id, { status: "rejected" }),
        (response: ApiResponse) => {
          if (response.isSuccess) {
            toast?.success(t("savedSuccessfully"));
            window.location.reload();
          } else {
            response.errorMessages.forEach((errorMessage) => {
              toast?.error(errorMessage);
            });
          }
        }
      );
    }
  };
  const saveData = async (status: any) => {
    let apiData: any = {
      is_available: status,
    };

    const response: ApiResponse = await updateTutor(apiData);
    if (response.isSuccess) {
      toast?.success("savedSuccessfully");
      window.location.reload();
    } else {
      response.errorMessages.forEach((errorMessage) => {
        toast?.error(errorMessage);
      });
    }
  };
  useEffect(() => {
    getNewStudents();
  }, []);

  return (
    <div className="flex flex-col w-full h-full gap-6 pt-6 bg-gray-50 ">
      <h1 className="px-8 text-2xl font-semibold text-gray-900 ">
        {t("newStudents")}
      </h1>
      <div className="flex flex-col w-full h-full gap-6 px-8 py-4 bg-white">
        <Switch.Group as="div" className="flex items-center gap-2">
          <Switch
            checked={enabled}
            onChange={(e: any) => {
              saveData(!enabled);
              setEnabled((prev: boolean) => !prev);
            }}
            className={classNames(
              enabled ? "bg-brandblue-600" : "bg-gray-200",
              "relative inline-flex h-6 w-11 z-10 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
            )}
          >
            <span className="sr-only">Use setting</span>
            <span
              aria-hidden="true"
              className={classNames(
                enabled
                  ? "rtl:-translate-x-5 ltr:translate-x-5"
                  : "translate-x-0",
                "pointer-events-none inline-block h-5 w-5  z-50 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
              )}
            />
          </Switch>
          <Switch.Label
            as="span"
            className="text-base leading-4 text-gray-600 rtl:mr-3 ltr:ml-3"
          >
            {t("availableToReceive")}
          </Switch.Label>
        </Switch.Group>
        {!!requests &&
          requests?.map((request: RequestsModel) => {
            return (
              <AppointmentsRequestsCard
                changeRequestStatus={changeRequestStatus}
                request={request}
                showModal={false}
              />
            );
          })}
      </div>
    </div>
  );
}
